import { classSet } from '@platform/ui-library';
import { default as DOMPurify } from 'dompurify';
import { marked } from 'marked';
import { FC, useMemo } from 'react';
import markdownStyles from './Markdown.module.scss';

type MarkdownProps = {
  className?: string;
  content: string;
};

export const Markdown: FC<MarkdownProps> = ({
  className,
  content
}) => {
  const html = useMemo(() => parseMarkdown(content), [content]);

  return (
    <div
      className={classSet([markdownStyles.markdown, className])}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

/**
 * Converts Markdown to sanitized HTML using `marked` for parsing
 * and `DOMPurify` for XSS protection.
 */
const parseMarkdown = (markdown: string): string => {
  const rawHtml = marked.parse(markdown, { async: false });
  return DOMPurify.sanitize(rawHtml);
};
